export default __webpack_public_path__ + "static/c13-a1351f5e6e0ac37c8a09c5899a09bdbf.png";